(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-documents"] && !Shopify.designMode) return;
  try {
    (function () {
    const API_URL = 'https://aworis-shopworker.sirowa.workers.dev/customer-upload';
    const shopDomain = 'pm2qvi-01.myshopify.com';

    const firstNameInput = document.getElementById('firstNameInput');
    const lastNameInput = document.getElementById('lastNameInput');
    const companyInput = document.getElementById('companyInput');
    const streetInput = document.getElementById('streetInput');
    const postcodeInput = document.getElementById('postcodeInput');
    const cityInput = document.getElementById('cityInput');
    const countrySelect = document.getElementById('countrySelect');
    const phoneInput = document.getElementById('phoneInput');
    const vatInput = document.getElementById('vatInput');
    const doctorNumberInput = document.getElementById('doctorNumberInput');

    async function loadFileUrl() {
      const fileGidElement = document.getElementById('existing_file_gid');
      if (!fileGidElement) return;

      const fileGid = fileGidElement.value;
      if (!fileGid || !fileGid.startsWith('gid://')) return;

      try {
        const response = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Shop-Domain': shopDomain,
            'X-Shopify-Topic': 'shopworker/webrequest',
          },
          body: JSON.stringify({
            action: 'get_file_url',
            file_gid: fileGid,
          }),
        });

        const result = await response.json();
        if (result.success && result.url) {
          const fileUrl = result.url;

          const urlParts = fileUrl.split('/');
          const fileNameWithParams = urlParts[urlParts.length - 1];
          const fileName = fileNameWithParams.split('?')[0];
          const fileExtension = fileName.split('.').pop().toLowerCase();

          document.getElementById('viewFileLink').href = fileUrl;
          document.getElementById('viewFileLink').style.display = 'inline-flex';

          const previewContainer = document.getElementById('filePreviewContainer');
          previewContainer.style.display = 'block';

          document.getElementById('fileName').textContent = fileName;

          const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
          if (imageExtensions.includes(fileExtension)) {
            const imgElement = document.getElementById('filePreview');
            imgElement.src = fileUrl;
            imgElement.style.display = 'block';
          }
        }
      } catch (error) {
        console.error('Error fetching file URL:', error);
      }
    }

    document.addEventListener('DOMContentLoaded', loadFileUrl);
    loadFileUrl();

    const fileToBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64Data = reader.result.split(',')[1];
          resolve(base64Data);
        };
        reader.onerror = (error) => reject(error);
      });

    const saveProfileBtn = document.getElementById('saveProfileBtn');
    const profileStatusDiv = document.getElementById('profileStatus');

    if (saveProfileBtn) {
      saveProfileBtn.addEventListener('click', async () => {
        if (!doctorNumberInput?.value?.trim()) {
          alert('Please enter your doctor number or trade number.');
          doctorNumberInput.focus();
          return;
        }
        if (!phoneInput?.value?.trim()) {
          alert('Please enter your phone number.');
          phoneInput.focus();
          return;
        }
        const customerId = document.getElementById('customer_id').value;
        saveProfileBtn.disabled = true;
        const originalText = saveProfileBtn.innerText;
        saveProfileBtn.innerText = 'Saving...';
        profileStatusDiv.style.display = 'none';

        try {
          const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Shop-Domain': shopDomain,
              'X-Shopify-Topic': 'shopworker/webrequest',
            },
            body: JSON.stringify({
              action: 'save_profile',
              customer_gid: 'gid://shopify/Customer/' + customerId,
              first_name: firstNameInput?.value?.trim() || '',
              last_name: lastNameInput?.value?.trim() || '',
              company_name: companyInput?.value?.trim() || '',
              street: streetInput?.value?.trim() || '',
              postcode: postcodeInput?.value?.trim() || '',
              city: cityInput?.value?.trim() || '',
              country: countrySelect?.value || '',
              phone: phoneInput?.value?.trim() || '',
              vat_code: vatInput?.value?.trim() || '',
              doctor_number: doctorNumberInput?.value?.trim() || '',
            }),
          });

          const result = await response.json();
          profileStatusDiv.style.display = 'block';
          if (result.success) {
            profileStatusDiv.style.backgroundColor = '#d4edda';
            profileStatusDiv.style.color = '#155724';
            profileStatusDiv.textContent = '✓ ' + result.message;
          } else {
            throw new Error(result.error || 'Server error');
          }
        } catch (error) {
          console.error('Save profile error:', error);
          profileStatusDiv.style.display = 'block';
          profileStatusDiv.style.backgroundColor = '#f8d7da';
          profileStatusDiv.style.color = '#721c24';
          profileStatusDiv.textContent = '✕ Error: ' + error.message;
        } finally {
          saveProfileBtn.disabled = false;
          saveProfileBtn.innerText = originalText;
        }
      });
    }

    const uploadBtn = document.getElementById('uploadBtn');
    const fileInput = document.getElementById('fileInput');
    const descriptionInput = document.getElementById('descriptionInput');
    const statusDiv = document.getElementById('uploadStatus');
    const deleteFileBtn = document.getElementById('deleteFileBtn');

    if (deleteFileBtn) {
      deleteFileBtn.addEventListener('click', async (event) => {
        event.preventDefault();
        if (!confirm('Delete the uploaded document?')) return;

        const customerId = document.getElementById('customer_id').value;
        const deleteStatusDiv = document.getElementById('deleteStatus');
        deleteFileBtn.disabled = true;
        const originalDeleteText = deleteFileBtn.innerText;
        deleteFileBtn.innerText = 'Deleting...';
        deleteStatusDiv.style.display = 'none';

        try {
          const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Shop-Domain': shopDomain,
              'X-Shopify-Topic': 'shopworker/webrequest',
            },
            body: JSON.stringify({
              action: 'delete_document',
              customer_gid: 'gid://shopify/Customer/' + customerId,
              customer_id: customerId,
            }),
          });

          const result = await response.json();
          deleteStatusDiv.style.display = 'block';

          if (result.success) {
            deleteStatusDiv.style.backgroundColor = '#d4edda';
            deleteStatusDiv.style.color = '#155724';
            deleteStatusDiv.textContent = '✓ Success: ' + result.message;
            setTimeout(() => location.reload(), 1200);
          } else {
            throw new Error(result.error || 'Server returned an error');
          }
        } catch (error) {
          console.error('Delete error:', error);
          deleteStatusDiv.style.display = 'block';
          deleteStatusDiv.style.backgroundColor = '#f8d7da';
          deleteStatusDiv.style.color = '#721c24';
          deleteStatusDiv.textContent = '✕ Error: ' + error.message;
        } finally {
          deleteFileBtn.disabled = false;
          deleteFileBtn.innerText = originalDeleteText;
        }
      });
    }

    if (!uploadBtn) return;

    uploadBtn.addEventListener('click', async () => {
      const customerId = document.getElementById('customer_id').value;
      const file = fileInput.files[0];

      if (!file) {
        alert('Please select a file first.');
        return;
      }

      const commercialBuyerCheckbox = document.getElementById('commercialBuyerCheckbox');
      if (!commercialBuyerCheckbox?.checked) {
        alert('Please confirm that you act as a commercial buyer before uploading.');
        return;
      }

      const agreeCheckbox = document.getElementById('agreeCheckbox');
      if (!agreeCheckbox?.checked) {
        alert('Please agree to the Terms and Conditions before uploading.');
        return;
      }

      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        alert('Please select a valid file type: JPEG, JPG, PNG, or PDF.');
        return;
      }

      uploadBtn.disabled = true;
      const originalText = uploadBtn.innerText;
      uploadBtn.innerText = 'Uploading...';
      statusDiv.style.display = 'none';

      try {
        const base64Content = await fileToBase64(file);

        const payload = {
          customer_gid: 'gid://shopify/Customer/' + customerId,
          customer_id: customerId,
          file_base64: base64Content,
          filename: file.name,
          mime_type: file.type,
          documents_description: descriptionInput?.value?.trim() || '',
        };

        const response = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Shop-Domain': shopDomain,
            'X-Shopify-Topic': 'shopworker/webrequest',
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        statusDiv.style.display = 'block';
        if (result.success) {
          statusDiv.style.backgroundColor = '#d4edda';
          statusDiv.style.color = '#155724';
          statusDiv.textContent = '✓ Success: ' + result.message;
          fileInput.value = '';
          if (descriptionInput) descriptionInput.value = '';

          setTimeout(() => location.reload(), 2000);
        } else {
          throw new Error(result.error || 'Server error');
        }
      } catch (error) {
        console.error('Submission error:', error);
        statusDiv.style.display = 'block';
        statusDiv.style.backgroundColor = '#f8d7da';
        statusDiv.style.color = '#721c24';
        statusDiv.textContent = '✕ Error: ' + error.message;
      } finally {
        uploadBtn.disabled = false;
        uploadBtn.innerText = originalText;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-preset-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    const PRESET_SELECTOR = '[data-quantity-preset]';

    function normalizeToStep5(value) {
      const num = parseInt(value, 10);
      if (Number.isNaN(num) || num < 5) {
        return 5;
      }
      const step = 5;
      let rounded = Math.round(num / step) * step;
      if (rounded < 5) {
        rounded = 5;
      }
      return rounded;
    }

    function enhancePresetBlock(root) {
      const buttons = root.querySelectorAll('[data-quantity-value]');
      if (!buttons.length) return;

      const form = root.closest('form');
      if (!form) return;

      const quantityInput = form.querySelector('input[name="quantity"]');
      if (!quantityInput) return;

      function syncButtonsWithQuantity(value) {
        const strValue = String(value);

        buttons.forEach((btn) => {
          const isActive = btn.getAttribute('data-quantity-value') === strValue;

          if (isActive) {
            btn.classList.add('is-active');
            btn.setAttribute('aria-pressed', 'true');
          } else {
            btn.classList.remove('is-active');
            btn.setAttribute('aria-pressed', 'false');
          }
        });
      }

      function setQuantity(value) {
        const normalized = normalizeToStep5(value);

        const update = () => {
          quantityInput.value = normalized;
          syncButtonsWithQuantity(normalized);
        };

        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }
      }

      // Инициализация: приводим к кратному 5 и подсвечиваем кнопку
      (function initQuantity() {
        const current = quantityInput.value;
        if (!current) {
          setQuantity(5);
        } else {
          setQuantity(current);
        }
      })();

      // Клики по кнопкам
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.getAttribute('data-quantity-value');
          setQuantity(value);
        });
      });

      // Пользователь руками меняет инпут
      quantityInput.addEventListener('change', () => {
        setQuantity(quantityInput.value);
      });
    }

    function init() {
      const blocks = document.querySelectorAll(PRESET_SELECTOR);
      blocks.forEach(enhancePresetBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
